export default {"src":"/_next/static/media/new-window.10b9922a.svg","height":14,"width":15};